/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export interface IImportTmdbCreditsBody {
  collectionId: number;
  tmdbId: number;
  mediaType: 'movie' | 'tv';
}

export const importTmdbSummarySchema = z.object({
  collectionId: z.number(),
  peopleLinked: z.number(),
  creditsUpserted: z.number(),
  castSkipped: z.number(),
});

export type IImportTmdbSummary = z.infer<typeof importTmdbSummarySchema>;

export const importTmdbCreditsResponseSchema = createApiResponseSchema(
  importTmdbSummarySchema,
) as import('zod').ZodSchema<IAPI<IImportTmdbSummary>>;

export type IImportTmdbCreditsResponse = IAPI<IImportTmdbSummary>;
